<template>
  <div class="basic-info">
    <div class="text-body-3 text-secondary-1">Basic info</div>

    <Grid gtc="auto 1fr" gap="var(--r-space-sm) var(--r-space-lg)" class="description text-secondary-1 q-pl-md q-mt-sm">
      <div class="text-lowercase-btn">Job</div>
      <div class="text-body-1">{{ contact.job || 'N/A' }}</div>

      <div class="text-lowercase-btn">Phone</div>
      <div class="text-body-1">{{ contact.phone || 'N/A' }}</div>

      <div class="text-lowercase-btn">Mobile phone</div>
      <div class="text-body-1">{{ contact.mobile_phone || 'N/A' }}</div>

      <div class="text-lowercase-btn">Email</div>
      <div class="text-body-1">{{ contact.email || 'N/A' }}</div>

      <template v-if="showMore">
        <div class="text-lowercase-btn">Address 1</div>
        <div class="text-body-1">{{ contact.addresses[0].address_1 || 'N/A' }}</div>

        <div class="text-lowercase-btn">Address 2</div>
        <div class="text-body-1">{{ contact.addresses[0].address_2 || 'N/A' }}</div>

        <div class="text-lowercase-btn">Postcode</div>
        <div class="text-body-1">{{ contact.addresses[0].post_code || 'N/A' }}</div>

        <div class="text-lowercase-btn">City</div>
        <div class="text-body-1">{{ contact.addresses[0].city || 'N/A' }}</div>

        <div class="text-lowercase-btn">State</div>
        <div class="text-body-1">{{ contact.addresses[0].state || 'N/A' }}</div>

        <div class="text-lowercase-btn">Country</div>
        <div class="text-body-1">{{ contact.addresses[0].country || 'N/A' }}</div>
      </template>

      <ShowMoreLess v-model="showMore" />
    </Grid>
  </div>
</template>

<script>
// Libraries
// Components
import ShowMoreLess from '@/reusable/ShowMoreLess'

export default {
  components: {
    ShowMoreLess
  },

  props: {
    contact: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    showMore: false
  })
}
</script>

<style lang="scss" scoped></style>
